import React from 'react';
import PropTypes from 'prop-types';

import MusicLinkThumbnail from 'components/dashboard/music-links-content/MusicLinkThumbnail';
import MusicLinkName from 'components/dashboard/music-links-content/MusicLinkName';
import MusicLinkSource from 'components/dashboard/music-links-content/MusicLinkSource';
import MusicLinkPublishedCheckbox from 'components/dashboard/music-links-content/MusicLinkPublishedCheckbox';
import MusicLinkDeleteIcon from 'components/dashboard/music-links-content/MusicLinkDeleteIcon';

import './MusicLinkItemHeaderContent.css';

function MusicLinkItemHeaderContent({ item, patchMusicLinkError }) {
  return (
    <div className="music-link-item-header-content__component">
      {/* Thumbnail */}
      <div className="thumbnail">
        <MusicLinkThumbnail
          itemThumbnail={item.music_cover}
        />
      </div>

      {/* Link Info */}
      <div className="link-info">
        <div className="link-name">
          <MusicLinkName
            key={`music_link_name_key_${item.id}`}
            musicLinkName={item.link_name}
            musicLinkId={item.id}
          />
        </div>
        <div className="link-url">
          <MusicLinkSource
            key={`music_link_source_key_${item.id}`}
            musicLinkName={item.link_source}
            musicLinkId={item.id}
            patchMusicLinkError={patchMusicLinkError}
          />
        </div>
      </div>

      {/* Is Published */}
      <div className="is-published">
        <MusicLinkPublishedCheckbox
          musicLinkId={item.id}
          isPublished={item.is_published}
        />
      </div>

      {/* Delete icon */}
      <MusicLinkDeleteIcon musicLinkId={item.id} />
    </div>
  );
}

MusicLinkItemHeaderContent.propTypes = {
  item: PropTypes.object.isRequired,
  patchMusicLinkError: PropTypes.object,
};

MusicLinkItemHeaderContent.defaultProps = {
  patchMusicLinkError: null,
};

export default MusicLinkItemHeaderContent;
